export const showMaintenanceAlert = () => {
    const sd = new Date("2025-04-22T00:30:00")
    const ed = new Date("2025-04-22T04:00:00")
    const now = new Date()

    const isDuringMaintenance = now > sd && now < ed

    if (isDuringMaintenance) {
        alert(
            "[시스템 점검 안내]\n\n" +
            "시스템 점검 중 입니다.\n\n" +
            "⦁ 점검 기간 : 2025년 4월 22일(화) 01:00 ~ 04:00 (3H 예정)\n" +
            "※ 점검은 예정된 시간보다 단축 또는 연장될 수 있습니다.\n\n" +
            "서비스 이용에 불편을 드려 대단히 죄송합니다.",
        )
        return true
    }
    return false
}